/* eslint-disable default-param-last */
import { SHOW_BID_DETAILS } from 'actionTypes/bidDetailsActionTypes';

const initialState = {
  status: false,
  selectedBid: null,
};

const bidDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_BID_DETAILS:
      return {
        ...state,
        status: action.payload.status,
        selectedBid: action.payload.selectedBid,
      };

    default:
      return state;
  }
};

export default bidDetailsReducer;
